import {BulkOperationResult, ProjectTimeBulkOperationResult, WorkingTimeBulkOperationResult} from "@/shared/timr";
import * as BootstrapModal from "@/shared/ui/bootstrapModal";

export function buildBulkResultMessage(result: BulkOperationResult, messageKeyPrefix: string): string {
	let message = messages.withArguments(messageKeyPrefix + "updated", result.updated, result.total);

	if (result.locked) {
		message += addMessageLine(messageKeyPrefix + "locked", result.locked);
	}
	if (result.insufficientRights) {
		message += addMessageLine(messageKeyPrefix + "insufficientRights", result.insufficientRights);
	}
	return message;
}

function addMessageLine(messageKey: string, value: number): string {
	return "<br /><br />" + $.validator.format(messages[messageKey], value.toString());
}

export function showRecordingBulkResult(result: WorkingTimeBulkOperationResult | ProjectTimeBulkOperationResult | BulkOperationResult, messageKeyPrefix: string) {
	if ((result as WorkingTimeBulkOperationResult).balanced || (result as WorkingTimeBulkOperationResult).createdByRequestOrDateSpan) {
		showWorkingTimeBulkResult(result as WorkingTimeBulkOperationResult, messageKeyPrefix);
	} else if ((result as ProjectTimeBulkOperationResult).taskLocked || (result as ProjectTimeBulkOperationResult).taskNotAssigned) {
		showProjectTimeBulkResult(result as ProjectTimeBulkOperationResult, messageKeyPrefix);
	} else {
		showBulkOperationResult(result, messageKeyPrefix);
	}
}

export function showWorkingTimeBulkResult(result: WorkingTimeBulkOperationResult, messageKeyPrefix: string) {
	let message = buildBulkResultMessage(result, messageKeyPrefix);

	if (result.balanced) {
		message += addMessageLine(messageKeyPrefix + "balanced", result.balanced);
	}
	if (result.createdByRequestOrDateSpan) {
		message += addMessageLine(messageKeyPrefix + "createdByRequestOrDateSpan", result.createdByRequestOrDateSpan);
	}
	showBulkOperationWarning(message, messageKeyPrefix);
}

export function showProjectTimeBulkResult(result: ProjectTimeBulkOperationResult, messageKeyPrefix: string) {
	let message = buildBulkResultMessage(result, messageKeyPrefix);

	if (result.taskLocked) {
		message += addMessageLine(messageKeyPrefix + "taskLocked", result.taskLocked);
	}
	if (result.taskNotAssigned) {
		message += addMessageLine(messageKeyPrefix + "taskNotAssigned", result.taskNotAssigned);
	}
	showBulkOperationWarning(message, messageKeyPrefix);
}

export function showBulkOperationResult(result: BulkOperationResult, messageKeyPrefix: string) {
	const message = buildBulkResultMessage(result, messageKeyPrefix);
	showBulkOperationWarning(message, messageKeyPrefix);
}

function showBulkOperationWarning(message: string, messageKeyPrefix: string) {
	BootstrapModal.warn({
		title: messageKeyPrefix + "title",
		message: message,
		escapeText: false
	});
}
